
newChangeLogController = (ChangeLogService, authors, moment, $q, Principal) ->
    'ngInject'

    @authors = authors
    @scopeOptions = ChangeLogService.scopeOptions
    @data =
        author_id: parseInt(Principal.id)
        scope: 'everyone'
        published: moment()

    @save = (data) ->
        return ChangeLogService.create(data)

    return


stateConfig = ($stateProvider) ->
    'ngInject'

    $stateProvider.state 'changeLog.new',
        url: '/new'
        templateUrl: 'changeLog/new'
        controller: newChangeLogController
        controllerAs: 'ctrl'
        resolve:
            authors: (ChangeLogService) ->
                'ngInject'
                return ChangeLogService.getAuthors()

    return


module.config stateConfig
